module.exports = __webpack_public_path__ + "assets/images/project/satellite-gifs/meta-desktop.gif?v=6e26892f";